<template>
  <div id="project-analysis-text-theme" style="padding: 0 1.5rem; position: relative">
    <Accordion
      class="main__tabs"
      title-element-type="h3"
      icon-location="right"
      :expand="true"
      :background="'var(--base-lighter-ui-colour);'"
      :iconColor="'var(--base-lighter-ui-colour)'"
      style="position: relative"
    >
      <template #heading>
        <div class="main__collapsible-chart-title">
          <h3>
            <VisibleText style="margin: 0 1rem">Saved themes:</VisibleText>
            <span>{{ sortedThemes.length }}</span>
          </h3>
        </div>
        <!-- todo remove or move -->
        <div style="display: flex; flex-direction: row; margin-left: 1rem">
          <button
            aria-label="table view"
            :class="[
              'chart-header__display-type-btn',
              { 'selected-btn': themesTabView !== 'charts' },
            ]"
            type="button"
            @click="changeThemesTabView()"
            :disabled="!sortedThemes.length"
          >
            <SvgIconMeaningful
              style="cursor: pointer; padding: 0; height: 1.5rem; margin-left: -0.3rem"
              class="complete-icon-svg"
              icon="table"
              title="table"
            />
          </button>
          <button
            aria-label="chart view"
            type="button"
            cursor="pointer"
            :class="[
              'chart-header__display-type-btn',
              { 'selected-btn': themesTabView == 'charts' },
            ]"
            @click="changeThemesTabView()"
            :disabled="!sortedThemes.length"
          >
            <SvgIconMeaningful
              style="cursor: pointer; height: 1.5rem; margin-left: -0.3rem"
              class="complete-icon-svg"
              icon="chart"
              title="chart"
            />
          </button>
        </div>
        <!-- TODO add more functionality and options to text table generation -->
        <!-- <div v-if="themesTabView == 'themes'">
            <div @click="showReportSettings = !showReportSettings"
              style="text-decoration: underline; margin-left: 1rem; margin-top: 0.5rem; cursor: pointer; color: var(--primary); font-size: 0.9rem;">
              <VisibleText>
                Report settings</VisibleText>
            </div>

            <div style="
                  z-index: 10;
                  background-color: white;
                  border-top: 0;
                  border-radius: 0 0 4px 4px;
                  color: var(--base-colour);
                  position: absolute;
                  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
                  border: 1px solid var(--outline-colour);
                  border-radius: 8px;
                  margin-left: 8rem;
                  margin-top:-2rem;
                  width: 15rem;
                  padding: 0.5rem;
                " v-if="showReportSettings
                ">

              <div style="display: flex; flex-direction: column;">
                <div style="display: flex; flex-direction: row">
                  <VisibleText>Include table in report:</VisibleText>
                  <input style="margin-left:1rem;" type="checkbox" />
                </div>

                <VisibleText>Include in table:</VisibleText>

                <div style="display: flex; flex-direction: row">
                  <VisibleText style="width: 70%; margin-left: 1rem;">Coverage percent:</VisibleText>
                  <input style="margin-left:1rem;" type="checkbox" />
                </div>
                <div style="display: flex; flex-direction: row">
                  <VisibleText style="width: 70%; margin-left: 1rem;">Coverage fractions:</VisibleText>
                  <input style="margin-left:1rem;" type="checkbox" />
                </div>
                <div style="display: flex; flex-direction: row">
                  <VisibleText style="width: 70%; margin-left: 1rem;">Keywords:</VisibleText>
                  <input style="margin-left:1rem;" type="checkbox" />
                </div>
                <div style="display: flex; flex-direction: row">
                  <VisibleText style="width: 70%; margin-left: 1rem;">Experts/notes:</VisibleText>
                  <input style="margin-left:1rem;" type="checkbox" />
                </div>
                <div style="display: flex; flex-direction: row">
                  <VisibleText style="width: 70%; margin-left: 1rem;">Sentiment chart:</VisibleText>
                  <input style="margin-left:1rem;" type="checkbox" />
                </div>
              </div>


            </div>
          </div> -->
        <!-- </div> -->
        <button
          type="button"
          class="theme__helper-options-btn"
          style="font-size: 1rem; margin-left: auto; width: auto"
          @click="isEditModalVisible = true"
          :disabled="propReadOnly"
        >
          <SvgIconDecorative icon="editAlt" />
          <VisibleText>Edit themes</VisibleText>
        </button>
        <button
          style="margin-left: auto; font-size: 1rem; margin: 0 1rem"
          class="theme__auto-generate"
          @click="isAutoGenerateModalVisible = true"
        >
          <VisibleText>Generate themes</VisibleText>
        </button>
      </template>
      <template #default v-if="sortedThemes">
        <!-- TODO REMOVE AND ADD JUST TO REPORTS BUT MAKE IT NICER TO GO LOOK IN REPORTS -->
        <div v-if="themesTabView == 'charts'" style="display: flex; flex-direction: column">
          <div style="width: 100%; position: relative" v-if="isAddingCharts">
            <span
              class="also-found__loading-spinner spinner"
              style="
                position: absolute;
                height: 2rem;
                width: 2rem;
                top: -2rem;
                left: 0;
                right: 0;
                margin-left: auto;
                margin-right: auto;
              "
            ></span>
          </div>

          <div
            style="display: flex; flex-direction: column"
            v-if="sortedThemes.length && !isAddingCharts"
          >
            <button
              style="margin-right: 2rem; margin-top: 2rem; width: 10rem"
              class="theme__auto-generate"
              @click="showCreateThemeChartModal"
              :disabled="!sortedThemes.length"
            >
              <VisibleText>Add theme chart</VisibleText>
            </button>
            <MessageBlock
              style="width: 50%"
              message-type="information"
              title="No charts created"
              v-if="!localAllCharts.length"
            >
              Generate a chart based on your themes
            </MessageBlock>
          </div>
          <div>
            <div
              v-for="(chartData, index) in localAllCharts"
              :key="index"
              style="border: 1px solid var(--outline-colour); border-radius: 4px; margin: 2rem"
            >
              <PerformanceCharts
                v-if="chartData.chart_data && chartData.chart_data.length"
                :chart-data="chartData.chart_data"
                :savedThreshold="-1"
                :isLoading="false"
                @deleteChart="deleteChart(index)"
                :filtered_by="chartData.filtered_by"
                :isThematic="true"
                :isSegmented="chartData.segmented_by"
                :alternative_x="'thematicScore'"
                :alternative_y="'thematicLabel'"
                :alternative_x_hover="'thematicScoreHover'"
                :alternative_y_hover="'thematicThemesHover'"
              />
            </div>
            <MessageBlock
              message-type="information"
              title="No themes found"
              v-if="!sortedThemes.length"
            >
              Auto-generate a theme or create a new one.
            </MessageBlock>
            <CreateNewThemeChart
              v-if="isCreateThemeChartModal"
              :widerFormat="true"
              :show="isCreateThemeChartModal"
              :sortedThemes="sortedThemes"
              :filterParams="textAnalysisObject.filterParams ? textAnalysisObject.filterParams : {}"
              @confirmSelection="addNewChart"
              @close-modal="closeCreateThemeChartModal"
            />
          </div>
        </div>

        <div
          v-if="themesTabView == 'themes'"
          style="padding: 1rem; height: 40rem; overflow-y: auto"
        >
          <div style="display: flex; flex-direction: row">
            <!----- NO SAVED THEMES MESSAGE ---->
            <MessageBlock
              message-type="information"
              title="No themes found"
              v-if="isThemeListEmpty || !localThemes.length"
              style="width: 50%"
            >
              Generate a theme or create a new one.
            </MessageBlock>

            <!----- THEME LIST ---->
            <div v-else style="margin-left: 2rem; position: relative" :style="mainThemesWidth">
              <div
                style="
                  display: flex;
                  width: 92%;
                  margin-top: 1rem;
                  margin-right: auto;
                  margin-left: 2rem;
                "
              >
                <div
                  style="
                    display: flex;
                    width: 100%;
                    align-items: center;
                    border: 1px solid var(--outline-light-colour);
                    border-radius: 4px;
                    justify-content: space-between;
                    padding: 0.25rem 1rem;
                    background-color: var(--base-ui-colour);
                    border: 1px solid var(--outline-colour);
                    margin-bottom: 2rem;
                  "
                >
                  <div style="display: flex; flex-direction: row; position: relative; width: 20%">
                    <div style="margin: auto">
                      <div style="display: flex; flex-direction: row">
                        <div style="margin: auto; margin-right: 1rem; font-weight: 800">Themes</div>

                        <div style="display: flex; flex-direction: column">
                          <span style="font-size: 0.8rem"> Sort </span>
                          <div style="display: flex; flex-direction: row">
                            <ButtonIconOnly
                              :smaller="true"
                              style="
                                border: 1px solid var(--outline-colour);
                                background: var(--secondary-ui-colour);
                                border-radius: 4px;
                                margin: 0.5rem;
                              "
                              :icon="sortIcon"
                              @click-handler="showSortType = !showSortType"
                            >
                              <VisibleText style="font-weight: 800"
                                >sorting by: {{ textAnalysisObject.themesSortType }}</VisibleText
                              >
                            </ButtonIconOnly>
                            <ButtonIconOnly
                              :smaller="true"
                              style="
                                border: 1px solid var(--outline-colour);
                                background: var(--secondary-ui-colour);
                                border-radius: 4px;
                                margin: 0.5rem;
                              "
                              :icon="textAnalysisObject.themesSortOrder"
                              @click-handler="switchSortOrder"
                            >
                              <VisibleText style="font-weight: 800"
                                >sort order: {{ textAnalysisObject.themesSortOrder }}</VisibleText
                              >
                            </ButtonIconOnly>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="showSortType"
                      style="
                        z-index: 10;
                        background-color: white;
                        border-top: 0;
                        border-radius: 0 0 4px 4px;
                        color: var(--base-colour);
                        position: absolute;
                        margin-top: -2rem;
                        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
                        border: 1px solid var(--outline-colour);
                        border-radius: 8px;
                        margin-left: 12rem;
                        width: 13rem;
                      "
                    >
                      <div style="margin-left: 0.5rem; display: flex; flex-direction: row">
                        <div style="margin-top: 0.5rem; font-weight: 800">
                          <VisibleText> Select a sort type</VisibleText>:
                        </div>
                        <button
                          style="
                            border: 1px solid var(--outline-colour);
                            background: var(--secondary-ui-colour);
                            border-radius: 4px;
                            margin: 0.3rem 0.3rem 0 auto;
                            width: 1.5rem;
                            height: 1.5rem;
                          "
                          @click="showSortType = false"
                        >
                          <SvgIconMeaningful
                            style="cursor: pointer; width: 1rem; margin-left: -0.05rem"
                            class="complete-icon-svg"
                            icon="remove"
                            title="close"
                          />
                        </button>
                      </div>

                      <div class="theme-options-btn" @click="switchSort('coverage')">
                        <span style="margin-left: 0.5rem; margin-right: 0.5rem">%</span>
                        <VisibleText>Coverage</VisibleText>
                      </div>
                      <div
                        v-if="textAnalysisObject.includeSentiments == 'include'"
                        class="theme-options-btn"
                        @click="switchSort('sentiment')"
                      >
                        <span style="font-size: 1.25rem; margin: auto 0.5rem">☺</span>
                        <VisibleText>Sentiment</VisibleText>
                      </div>
                      <div class="theme-options-btn" @click="switchSort('alphabetical')">
                        <SvgIconDecorative icon="alphabet" />
                        <VisibleText>Alphabetical</VisibleText>
                      </div>
                      <div class="theme-options-btn" @click="switchSort('created')">
                        <SvgIconDecorative icon="timeAdd" />
                        <VisibleText>Created</VisibleText>
                      </div>
                      <!-- <div class="theme-options-btn" @click="switchSort('modified')">
                          <SvgIconDecorative icon="timeCheck" />
                          <VisibleText>Modified</VisibleText>
                        </div> -->
                    </div>

                    <div
                      style="
                        border-left: 0.15rem solid var(--primary);
                        height: 2rem;
                        margin-top: 0.5rem;
                      "
                    ></div>
                  </div>
                  <div
                    style="
                      display: flex;
                      flex-direction: row;
                      align-items: center;
                      justify-content: center;
                      position: relative;
                      width: 30%;
                      margin-right: auto;
                    "
                  >
                    <CoverageOptionsPopup
                      :showCoverageDetails="textAnalysisObject.showCoverageDetails"
                    ></CoverageOptionsPopup>
                  </div>
                </div>
              </div>

              <!-- THEMES ROW -->

              <div
                v-for="(theme, index) in localThemes"
                :key="index"
                style="
                  display: flex;
                  flex-direction: row;
                  margin-bottom: 1.5rem;
                  align-items: center;
                "
                :style="
                  !hasPreProcessedText || textAnalysisObject.includeSentiments == 'exclude'
                    ? 'margin-left: auto; margin-right: auto; position: relative;'
                    : ''
                "
              >
                <div
                  style="
                    z-index: 10;
                    background-color: white;
                    border-top: 0;
                    border-radius: 0 0 4px 4px;
                    color: var(--base-colour);
                    position: absolute;
                    margin-top: 2rem;
                    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
                    border: 1px solid var(--outline-colour);
                    border-radius: 8px;
                    margin-left: 2rem;
                    width: 13rem;
                  "
                  v-if="
                    showThemeCheckOptions.length &&
                    showThemeCheckOptions[showThemeCheckOptions.length - 1]._id == theme._id
                  "
                >
                  <div style="margin-left: 0.5rem">
                    <div v-if="checkedThemes.length == 1">
                      <VisibleText> 1 theme selected</VisibleText>
                    </div>
                    <div v-if="checkedThemes.length > 1">
                      <span>{{ checkedThemes.length }}</span>
                      <VisibleText> themes selected</VisibleText>
                    </div>
                  </div>

                  <div @click="toggleTheme" class="theme-options-btn">
                    <SvgIconDecorative icon="search" />
                    <VisibleText>Filter</VisibleText>
                  </div>
                  <div
                    @click="duplicateTheme"
                    class="theme-options-btn"
                    :style="propReadOnly ? 'cursor: not-allowed' : 'cursor:pointer'"
                  >
                    <SvgIconDecorative icon="duplicate" />
                    <VisibleText>Duplicate</VisibleText>
                  </div>
                  <div
                    @click="onClickMergeAndDelete"
                    v-if="checkedThemes.length > 1"
                    class="theme-options-btn"
                    :style="propReadOnly ? 'cursor: not-allowed' : ''"
                  >
                    <SvgIconDecorative icon="merge" />
                    <VisibleText>Merge</VisibleText>
                  </div>
                  <div
                    @click="copyAndMerge(false)"
                    v-if="checkedThemes.length > 1"
                    class="theme-options-btn"
                    :style="propReadOnly ? 'cursor: not-allowed' : ''"
                  >
                    <SvgIconDecorative icon="copyMerge" />
                    <VisibleText>Copy and merge</VisibleText>
                  </div>

                  <div
                    @click="openEditSomeThemes"
                    class="theme-options-btn"
                    :style="propReadOnly ? 'cursor: not-allowed' : ''"
                  >
                    <SvgIconDecorative icon="edit" />
                    <VisibleText>Edit</VisibleText>
                  </div>
                  <div
                    @click="openSaveCTM"
                    v-if="checkedThemes.length == 1"
                    class="theme-options-btn"
                    :style="propReadOnly ? 'cursor: not-allowed' : ''"
                  >
                    <SvgIconDecorative icon="chain" />
                    <VisibleText>Link</VisibleText>
                  </div>
                  <div
                    @click="onClickDelete"
                    class="theme-options-btn"
                    :style="propReadOnly ? 'cursor: not-allowed' : ''"
                  >
                    <SvgIconDecorative icon="deleteIcon" />
                    <VisibleText>Delete</VisibleText>
                  </div>
                </div>
                <div
                  class="ctm-modal"
                  v-if="
                    showThemeCheckOptions.length &&
                    showThemeCheckOptions[showThemeCheckOptions.length - 1]._id == theme._id &&
                    isSaveToCTMVisible
                  "
                >
                  <div class="ctm-modal__inner" style="max-height: 40rem; overflow-y: auto">
                    <!-- Header -->
                    <div class="ctm-modal__header">
                      <VisibleText style="font-weight: 800">
                        Linking your theme to a model
                      </VisibleText>
                      <ButtonIconOnly
                        icon="remove"
                        class="modal-close-btn"
                        @click-handler="closeSavingToCTM"
                      >
                        <VisibleText>close</VisibleText>
                      </ButtonIconOnly>
                    </div>

                    <div style="line-height: 1rem">
                      {{ themeTypeDescription }}
                    </div>

                    <div v-if="checkedThemes[0].source.type === 'bert'">
                      <p>
                        <VisibleText>BERT-based models cannot be linked or unlinked.</VisibleText>
                      </p>
                    </div>
                    <div v-else-if="checkedThemes[0].source.type === 'ldi'">
                      <p>
                        <VisibleText>LDI-based models cannot be linked or unlinked.</VisibleText>
                      </p>
                    </div>
                    <div v-else-if="checkedThemes[0].source.type === 'lsi'">
                      <p>
                        <VisibleText>LDI-based models cannot be linked or unlinked.</VisibleText>
                      </p>
                    </div>
                    <div v-else>
                      <!-- Theme info -->
                      <div class="ctm-modal__section">
                        <!-- Warning: unlinked CTM theme -->
                        <div
                          v-if="
                            checkedThemes[0].source.type === 'ctm' &&
                            checkedThemes[0].source.link.manually_unlinked
                          "
                          class="message__block message__block--warning"
                        >
                          You have unlinked this theme from its original custom text model.
                          <div class="ctm-modal__row">
                            <button class="btn-save btn-default" @click="relinkThisCTM">
                              <SvgIconDecorative icon="add" />
                              <VisibleText>Relink theme</VisibleText>
                            </button>
                            <div style="margin-left: 1rem">
                              This will unlink you from any manually connected models.
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Status banner -->
                      <div
                        class="message__block message__block--information ctm-modal__section"
                        style="margin: 0"
                      >
                        <!-- Linked model -->
                        <div class="ctm-modal__row">
                          <span class="status-icon" :class="isLinked ? 'ok' : 'bad'">
                            <SvgIconMeaningful
                              title="Add or remove CTM link"
                              :icon="isLinked ? 'check' : 'remove'"
                            />
                          </span>

                          <VisibleText style="margin-left: 0.5rem; width: 10rem"
                            >Linked model:</VisibleText
                          >

                          <template v-if="isLinked">
                            <router-link
                              :to="'/custom-text-model/' + currentCTMGroupId"
                              target="_blank"
                              style="margin-left: 0.5rem"
                            >
                              {{ currentCTMGroupName }}
                              <SvgIconDecorative icon="externalLink" />
                            </router-link>

                            <button
                              class="btn-save btn-default remove-link-btn"
                              @click="removeThisCTM(checkedThemes[0])"
                            >
                              <SvgIconDecorative icon="minus" />
                              <VisibleText>Remove link</VisibleText>
                            </button>
                          </template>

                          <template v-else>
                            <VisibleText style="margin-left: 1rem; font-weight: 800">
                              Not linked to a custom text model
                            </VisibleText>
                          </template>
                        </div>

                        <!-- Linked theme -->
                        <div class="ctm-modal__row">
                          <span class="status-icon" :class="isLinkedToTheme ? 'ok' : 'bad'">
                            <SvgIconMeaningful
                              title="Add or remove CTM link"
                              :icon="isLinkedToTheme ? 'check' : 'remove'"
                            />
                          </span>

                          <VisibleText style="margin-left: 0.5rem; width: 12rem"
                            >Linked model theme:</VisibleText
                          >

                          <VisibleText v-if="isLinkedToTheme" style="font-weight: 800">
                            {{ currentCTMThemeName }}
                          </VisibleText>

                          <VisibleText v-else style="margin-left: 0.5rem; font-weight: 800">
                            Not linked to a custom text model theme
                          </VisibleText>
                        </div>

                        <!-- Current keywords -->

                        <div v-if="isLinkedToTheme">
                          <VisibleText>Current keywords:</VisibleText>
                          <div v-if="currentCTMKeywordObjects.length" class="keyword-scroll">
                            <div
                              v-for="(keyword, i) in currentCTMKeywordObjects"
                              :key="i"
                              class="keywords-input-badge pill ui-adaptable"
                              :style="{ backgroundColor: checkedThemes[0].theme_color }"
                            >
                              {{ keyword.keyword }}
                            </div>
                          </div>
                          <VisibleText v-else>None</VisibleText>
                        </div>
                      </div>

                      <!-- If not linked: choose CTM -->
                      <div v-if="!isLinked" class="ctm-modal__section">
                        <VisibleText
                          >Please select a custom text model to link your theme to:</VisibleText
                        >

                        <div class="ctm-list">
                          <div
                            v-for="model in fetchedCTMs"
                            :key="model._id"
                            class="hoverable-background"
                            :class="{ 'read-only': model.access_type === 'public__all' }"
                            @click="
                              setThisCTM(
                                model,
                                checkedThemes[0],
                                model.access_type === 'public__all',
                              )
                            "
                          >
                            <div class="ctm-name">{{ model.name }}</div>
                            <div class="ctm-owner">
                              <VisibleText>Owner:</VisibleText>
                              <span v-if="model.created_by.organization">Team:</span>
                              {{ model.created_by.name }}
                              <SvgIconMeaningful
                                v-if="model.created_by.name === profile.fullname"
                                icon="star"
                                title="is you"
                              />
                            </div>
                            <VisibleText v-if="model.access_type === 'public__all'"
                              >Read only</VisibleText
                            >
                          </div>
                        </div>

                        <!-- Create new CTM -->
                        <label><VisibleText>Or create a new Custom Text Model</VisibleText></label>
                        <div class="ctm-create-row">
                          <input v-model="modelAdd.modelName" placeholder="New model name" />
                          <CreateProject
                            v-if="modelAdd.modelName.length"
                            :project="modifiedNewGroup"
                            @projectCreated="newGroupCreated"
                            @projectCreationError="newGroupCreationError"
                          >
                            <VisibleText>Create Custom Text Model</VisibleText>
                          </CreateProject>
                        </div>
                      </div>

                      <!-- If linked but not linked to theme -->
                      <div v-if="isLinked && !isLinkedToTheme" class="ctm-modal__section">
                        <VisibleText>
                          This theme is not linked to a theme inside the selected custom text model.
                        </VisibleText>

                        <VisibleText style="margin-top: 1rem; font-weight: 800">
                          Themes in {{ currentCTMGroupName }}:
                        </VisibleText>

                        <VisibleText v-if="!fetchedCTMThemes.length">
                          This custom text model has no themes.
                        </VisibleText>

                        <div class="ctm-list">
                          <div
                            v-for="model_theme in fetchedCTMThemes"
                            :key="model_theme._id.$oid"
                            class="hoverable-background"
                            @click="setThisCTMTheme(model_theme._id.$oid, theme)"
                          >
                            <div class="ctm-name">{{ model_theme.name }}</div>
                          </div>
                        </div>

                        <div class="hoverable-background" @click="setNewCTMTheme">
                          <VisibleText>or create a new custom text model theme</VisibleText>
                          <button class="btn-save btn-default">
                            <VisibleText>Create theme</VisibleText>
                          </button>
                        </div>
                      </div>

                      <!-- If linked + linked to theme: show keyword sync -->
                      <div v-if="currentCTMTheme" class="ctm-modal__section">
                        <strong><VisibleText>New keywords in your project:</VisibleText></strong>
                        <p>
                          If you added new keywords, or new keywords were added to the linked model,
                          you can re-sync them here.
                        </p>
                        <div v-if="newKeywordsForTheme.length" class="keyword-scroll">
                          <div
                            v-for="(keyword, i) in newKeywordsForTheme"
                            :key="i"
                            class="keywords-input-badge pill ui-adaptable"
                            :style="{ backgroundColor: checkedThemes[0].theme_color }"
                          >
                            {{ keyword }}
                          </div>
                        </div>

                        <VisibleText v-else>
                          You have not added new keywords to be saved to this Custom Model.
                        </VisibleText>

                        <button
                          v-if="newKeywordsForTheme.length"
                          class="btn-save btn-default"
                          style="margin-top: 0.5rem"
                          :disabled="isCTMReadOnly"
                          @click="saveNewKeywords"
                        >
                          <SvgIconDecorative icon="add" />
                          <VisibleText>Save keywords to model</VisibleText>
                        </button>

                        <VisibleText v-if="isCTMReadOnly">
                          This is a Read-Only custom text model
                        </VisibleText>
                      </div>

                      <div v-if="newKeywordsFromCTM.length" class="ctm-sync-section">
                        <strong><VisibleText>New keywords from model:</VisibleText></strong>

                        <div class="keyword-scroll">
                          <div
                            v-for="(kw, i) in newKeywordsFromCTM"
                            :key="i"
                            class="keywords-input-badge pill ui-adaptable"
                            :style="{ backgroundColor: checkedThemes[0].theme_color }"
                          >
                            {{ kw }}
                          </div>
                        </div>

                        <button
                          class="btn-save btn-default"
                          :disabled="isCTMReadOnly"
                          @click="syncKeywordsFromCTM"
                        >
                          <SvgIconDecorative icon="merge" style="color: white" />
                          <VisibleText>Sync new keywords</VisibleText>
                        </button>
                      </div>

                      <div class="ctm-sync-section">
                        <strong><VisibleText>Save analysis learnings:</VisibleText></strong>
                        <p>
                          You can save a snapshot of your analysis to train this custom text model
                          from matches you kept, dropped, or modified.
                        </p>

                        <div style="display: flex; flex-direction: row">
                          <button
                            class="btn-save btn-default"
                            style="margin-top: 0.5rem"
                            :disabled="isCTMReadOnly || !currentCTMTheme || savingSnapshots"
                            @click="saveLearningSnapshots"
                          >
                            <SvgIconDecorative icon="add" />
                            <VisibleText>Save machine learning snapshots</VisibleText>
                          </button>

                          <div v-if="savingSnapshots">
                            <span
                              class="also-found__loading-spinner spinner"
                              style="margin: auto; margin: 1rem"
                            ></span>
                          </div>
                        </div>
                      </div>

                      <div v-if="Object.keys(learningResults).length" class="snapshot-section">
                        <div class="snapshot-title">A human accepted:</div>
                        <ul>
                          <li>
                            <span class="signal positive">✓</span>
                            <span>Keyword-only matches</span>
                            <strong>{{ learningResults.keyword_matches }}</strong>
                          </li>

                          <li>
                            <span class="signal positive">✓</span>
                            <span>Machine Learning notes</span>
                            <strong>{{ learningResults.ml_added_notes }}</strong>
                          </li>

                          <li>
                            <span class="signal negative">✕</span>
                            <span>ML-blocked keyword matches</span>
                            <strong>{{ learningResults.ml_blocked_keywords }}</strong>
                          </li>

                          <li>
                            <span class="signal negative">✕</span>
                            <span>Left unmatched</span>
                            <strong>{{ learningResults.no_matches }}</strong>
                          </li>
                        </ul>
                      </div>

                      <div v-if="Object.keys(learningResults).length" class="snapshot-section">
                        <div class="snapshot-title">A human took these actions:</div>
                        <ul>
                          <li>
                            <span class="signal positive">✓</span>
                            <span>Added notes</span>
                            <strong>{{ learningResults.human_notes }}</strong>
                          </li>

                          <li>
                            <span class="signal negative">✕</span>
                            <span>Dropped / blocked keyword matches</span>
                            <strong>{{ learningResults.human_blocked_keywords }}</strong>
                          </li>

                          <li>
                            <span class="signal negative">✕</span>
                            <span>Dropped / blocked ML notes</span>
                            <strong>{{ learningResults.human_dropped_ml_notes }}</strong>
                          </li>
                        </ul>
                      </div>

                      <div v-if="Object.keys(learningResults).length" class="snapshot-footer">
                        <span
                          >Out of
                          <strong>{{ learningResults.total_labeled }}</strong> responses</span
                        >
                        <span>{{ learningResults.positives }} positives</span>
                        <span>{{ learningResults.negatives }} negatives</span>
                        <span v-if="learningResults.overridden" class="snapshot-note">
                          This snapshot replaced the previous one.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <input
                  type="checkbox"
                  class="datasets__table-checkbox"
                  name="theme-checkbox"
                  :id="'theme-checkbox-' + theme._id + theme.created_on"
                  style="
                    width: 1.3rem;
                    height: 1.3rem;
                    margin-top: 0.5rem;
                    cursor: pointer;
                    margin-right: 1rem;
                  "
                  @click="addToShowThemeCheckOptions(theme)"
                  v-model="selectedBoxes[index]"
                />

                <!-- Main theme row content  -->
                <div style="display: flex; flex-direction: column; width: 90%">
                  <div
                    class="theme__list-row"
                    style="
                      display: flex;
                      flex-direction: row;
                      display: flex;
                      width: 100%;
                      align-items: center;
                      position: relative;
                    "
                  >
                    <!-- Theme title column -->
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        flex: 0 0 20%;
                        max-width: 20%;
                        min-width: 120px;
                        text-overflow: ellipsis;
                        text-align: left;
                      "
                    >
                      <div style="display: flex; flex-direction: row">
                        <div v-if="theme.theme_color">
                          <button
                            @click="showChangeColor(index)"
                            style="
                              border-radius: 1rem;
                              border: 1px solid var(--outline-colour);
                              height: 1.5rem;
                              width: 1.5rem;
                              margin-right: 0.5rem;
                            "
                            :style="{ 'background-color': theme.theme_color }"
                          ></button>
                        </div>

                        <div v-if="!propReadOnly">
                          <InputEditable
                            :value="theme.name"
                            :inputClass="'theme__list-row-title-input'"
                            :uuid="`saved-themes-${index}`"
                            :select="() => toggleTheme"
                            @updateInput="updateExistingThemeTitle(theme, $event)"
                          />
                        </div>
                        <div v-else>
                          {{ theme.name }}
                        </div>
                        <ColorPopup
                          :id="'themeColor' + theme._id + textAnalysisObject.last_modified_on"
                          :themeId="theme._id"
                          @changeThemeColor="changeThemeColor"
                          @close="showChangeColor(index)"
                          v-if="changingColor.includes(index)"
                        ></ColorPopup>

                        <div
                          v-if="duplicateIndex == index"
                          style="font-size: 0.7rem; color: var(--state-invalid-colour)"
                        >
                          <VisibleText
                            >No duplicate titles allowed. Please try another.</VisibleText
                          >
                        </div>
                      </div>

                      <SourcePopup :themeName="theme.name" :themeSource="theme.source" />
                    </div>
                    <!-- Bar -->
                    <div style="border-left: 0.2rem solid var(--primary); height: 3rem"></div>

                    <!-- Simple coverage section -->
                    <div
                      class="theme__list-row-coverage-title"
                      style="display: flex; flex-direction: row; flex: 0 0 4vw"
                    >
                      <div
                        v-if="themesPendingRefresh.includes(theme._id)"
                        style="position: relative"
                      >
                        <span
                          class="also-found__loading-spinner spinner"
                          style="
                            position: absolute;
                            top: 1rem;
                            left: 3rem;
                            height: 2rem;
                            width: 2rem;
                            margin: auto;
                          "
                        ></span>
                      </div>
                      <div v-if="themesReloading.includes(theme._id)" style="position: relative">
                        <span
                          class="also-found__loading-spinner spinner"
                          style="
                            position: absolute;
                            top: 1rem;
                            left: 3rem;
                            height: 2rem;
                            width: 2rem;
                            margin: auto;
                          "
                        ></span>
                      </div>
                      <CoveragePopup
                        style="width: 4vw"
                        :theme="theme"
                        :hasPreProcessedText="hasPreProcessedText"
                        :includeSmartCoverage="includeSmartCoverage"
                        :sortedResponsesLength="unsortedResponses.length"
                        :hasFilter="
                          Boolean(
                            textAnalysisObject.filterParams &&
                            Object.keys(textAnalysisObject.filterParams).length,
                          )
                        "
                      />

                      <SentimentPopup
                        v-if="textAnalysisObject.includeSentiments == 'include' && theme.sentiment"
                        :theme="theme"
                        :sortedResponsesLength="unsortedResponses.length"
                      />
                    </div>
                    <!-- Time series coverage section -->
                    <div
                      v-if="
                        themeDualAxisCharts[index] &&
                        themeDualAxisCharts[index].chart_data &&
                        themeDualAxisCharts[index].chart_data.length
                      "
                      class="theme__list-row-coverage"
                      style="
                        flex: 0 0 20vw; /* fixed width for chart */
                        max-width: 20vw;
                        min-width: 20vw;
                        overflow: hidden;
                      "
                    >
                      <PerformanceCharts
                        :chart-data="themeDualAxisCharts[index].chart_data"
                        :isLoading="false"
                        :isThematic="true"
                        :minimalMode="true"
                      />
                    </div>
                    <!-- Sentiments section -->
                    <SentimentCharts
                      v-if="
                        hasPreProcessedText &&
                        textAnalysisObject.includeSentiments == 'include' &&
                        (!themeDualAxisCharts[index] ||
                          !themeDualAxisCharts[index].chart_data ||
                          !themeDualAxisCharts[index].chart_data.length)
                      "
                      :pos-neg-data="generatePosNegData(findResponses(theme), theme.name)"
                    />
                    <!-- Keywords section -->
                    <div
                      class="theme__list-row-info"
                      style="position: relative; flex: 1 1 auto; min-width: 0; white-space: nowrap"
                    >
                      <EditableKeywordsPopup
                        :theme="theme"
                        :hasPreProcessedText="hasPreProcessedText"
                        :textAnalysisObject="textAnalysisObject"
                        :bannedKeywords="this.textAnalysisObject.bannedKeywords"
                        @addKeyword="addKeyword($event)"
                        @removeKeyword="removeKeyword($event)"
                        :isInThemeView="true"
                        :hideLabel="true"
                      />
                      <NotesPopup
                        :clientQuestionId="textAnalysisObject.selectedTextQuestion._id"
                        :themesLength="sortedThemes.length"
                        :theme="theme"
                        :themeIndex="index"
                        :allResponses="unsortedResponses"
                        :hasPreProcessedText="hasPreProcessedText"
                        @onRemoveNote="onRemoveNote($event)"
                        @selectThisResponse="selectThisResponse($event)"
                        @addNewNote="addNewNote($event)"
                        @updateTheme="this.$emit('updateTheme', $event)"
                        @refreshTheme="this.$emit('refreshTheme', $event)"
                        :showCoverageDetails="textAnalysisObject.showCoverageDetails"
                        :leftMargin="true"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <InsightsFeed
              :chart_insights="
                textAnalysisObject.chart_insights ? textAnalysisObject.chart_insights : []
              "
              :isAbsolute="true"
              @openStatus="insightsOpenStatus = !insightsOpenStatus"
            />
            <FindInsightsButton
              v-if="!textAnalysisObject.chart_insights || !textAnalysisObject.chart_insights.length"
              style="right: 2rem; position: absolute"
              @refresh_for_insights="$emit('refreshForInsights')"
            />
          </div>
        </div>
      </template>
    </Accordion>

    <!----- MODALS---->
    <ThemesEditModal
      ref="ThemesEditModalRef"
      :show="isEditModalVisible"
      :isEditThemes="true"
      :textAnalysisObject="textAnalysisObject"
      :propReadOnly="propReadOnly"
      :sortedThemes="sortedThemes"
      :hasPreProcessedText="hasPreProcessedText"
      :unsortedResponses="unsortedResponses"
      :includeSmartCoverage="includeSmartCoverage"
      @updateExistingThemeTitle="updateExistingThemeTitle"
      @updateTextObject="$emit('updateTextObject', $event)"
      @removeTheme="$emit('removeTheme', $event)"
      @bannedKeywordsModalIsVisible="isBannedKeywordsModalVisible = true"
      @closeModal="closeModalEditThemes"
      @updateTheme="$emit('updateTheme', $event)"
      @refreshTheme="$emit('refreshTheme', $event)"
    />
    <ThemesEditModal
      ref="ThemesEditSomeModalRef"
      :show="isEditSomeModalVisible"
      :isEditThemes="true"
      :textAnalysisObject="textAnalysisObject"
      :propReadOnly="propReadOnly"
      :sortedThemes="someSortedThemes"
      :hasPreProcessedText="hasPreProcessedText"
      :unsortedResponses="unsortedResponses"
      :includeSmartCoverage="includeSmartCoverage"
      @updateExistingThemeTitle="updateExistingThemeTitle"
      @updateTextObject="$emit('updateTextObject', $event)"
      @removeTheme="$emit('removeTheme', $event)"
      @bannedKeywordsModalIsVisible="isBannedKeywordsModalVisible = true"
      @closeModal="closeModalEditSomeThemes"
      @updateTheme="$emit('updateTheme', $event)"
      @refreshTheme="$emit('refreshTheme', $event)"
    />
    <ThemesAutoGenerateModal
      v-if="textAnalysisObject"
      ref="ThemesAutoGenerateModalRef"
      :hasPreProcessedText="hasPreProcessedText"
      :propReadOnly="propReadOnly"
      :includeSmartCoverage="includeSmartCoverage"
      :show="isAutoGenerateModalVisible"
      :textAnalysisObject="textAnalysisObject"
      :sortedThemes="sortedThemes"
      :unsortedResponses="unsortedResponses"
      :themesReloading="themesReloading"
      @updateExistingThemeTitle="updateExistingThemeTitle"
      @updateSelectedCustomModels="$emit('updateSelectedCustomModels', $event)"
      @updateTextObject="$emit('updateTextObject', $event)"
      @bannedKeywordsModalIsVisible="isBannedKeywordsModalVisible = true"
      @closeModal="closeModalAutoGenerate"
      @updateTheme="$emit('updateTheme', $event)"
      @refreshTheme="$emit('refreshTheme', $event)"
      @refreshThemes="$emit('refreshThemes', $event)"
    />
    <BannedKeywordsModal
      v-if="textAnalysisObject"
      :textAnalysisObject="textAnalysisObject"
      :propReadOnly="propReadOnly"
      :hasPreProcessedText="hasPreProcessedText"
      :show="isBannedKeywordsModalVisible"
      @closeModal="closeModalBannedKeywords"
    />
  </div>
</template>

<script>
// Components
import { CreateProject } from '@/pigeonline/wrapper';

import InputEditable from './ProjectAnalysisTextMain/UI/InputEditable.vue';
import SentimentCharts from './ProjectAnalysisTextMain/Components/SentimentCharts.vue';
import SvgIconDecorative from '@/components/UI/Svg/SvgIconDecorative.vue';
import MessageBlock from '@/components/UI/Message/MessageBlock.vue';
import { PigeonDocNodeModel } from '@/pigeondoc/wrapper';
import ButtonIconOnly from '@/components/UI/Button/ButtonIconOnly.vue';
import SvgIconMeaningful from '@/components/UI/Svg/SvgIconMeaningful.vue';

import ColorPopup from './Components/ColorPopup.vue';
import SourcePopup from './Components/SourcePopup.vue';
import CoveragePopup from './Components/CoveragePopup.vue';
import SentimentPopup from './Components/SentimentPopup.vue';
import CoverageOptionsPopup from './Components/CoverageOptionsPopup.vue';
//import KeywordsPopup from './Components/KeywordsPopup.vue';
import EditableKeywordsPopup from '@/components/Project/ProjectAnalysis/ProjectAnalysisText/Components/EditableKeywordsPopup.vue';

import NotesPopup from './Components/NotesPopup.vue';

import Accordion from '@/components/UI/Accordion.vue';

import PerformanceCharts from '@/components/Project/ProjectAnalysis/ProjectAnalysisPerformance/Components/PerformanceCharts.vue';
import InsightsFeed from '@/components/Project/ProjectAnalysis/Components/InsightsFeed.vue';
import FindInsightsButton from '@/components/Project/ProjectAnalysis/Components/FindInsightsButton.vue';

// Modal
import CreateNewThemeChart from './Modals/CreateNewThemeChart.vue';
import ThemesAutoGenerateModal from './ProjectAnalysisTextMain/Modals/ThemesAutoGenerate.vue';
import ThemesEditModal from './ProjectAnalysisTextMain/Modals/ThemesEdit.vue';
import BannedKeywordsModal from './ProjectAnalysisTextMain/Modals/BannedKeywords.vue';

import { fetchTopicModels, fetchGroups } from '@/components/CustomTopicModel/Utils/fetch.js';

import CustomTopicModelGroup from '@/components/CustomTopicModel/Models/CustomTopicModelGroup.js';
import CustomTopicModel from '@/components/CustomTopicModel/Models/CustomTopicModel.js';
// Utils
import moment from 'moment';

// Mixins
import textAnalysisMixin from './Mixins/textAnalysisMixin.js';
import themeColorsMixin from './Mixins/themeColorsMixin.js';
import customTopicModelService from '@/services/customTopicModelService.js';

export default {
  name: 'ProjectAnalysisTextTheme',
  mixins: [textAnalysisMixin, themeColorsMixin],
  components: {
    CreateProject,
    InputEditable,
    CreateNewThemeChart,
    ThemesAutoGenerateModal,
    ThemesEditModal,
    BannedKeywordsModal,
    SentimentCharts,
    PerformanceCharts,
    SvgIconDecorative,
    MessageBlock,
    // popups
    ColorPopup,
    EditableKeywordsPopup,
    NotesPopup,
    CoveragePopup,
    SentimentPopup,
    CoverageOptionsPopup,
    SourcePopup,
    Accordion,
    ButtonIconOnly,
    SvgIconMeaningful,
    InsightsFeed,
    FindInsightsButton,
  },
  props: {
    textAnalysisObject: {
      type: Object,
      required: false,
      default: () => {},
    },
    sortedThemes: {
      type: Array,
      default: () => [],
    },
    allCharts: {
      type: Array,
      default: () => [],
    },
    unsortedResponses: {
      type: Array,
      required: false,
      default: () => [],
    },
    hasPreProcessedText: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    includeSmartCoverage: {
      type: String,
      default: () => 'exclude',
    },
    themesReloading: {
      type: Array,
      default: () => [],
    },
    propReadOnly: {
      default: () => false,
      type: Boolean,
    },
    themesPendingRefresh: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      CUSTOM_TOPIC_MODEL_SERVICE: new customTopicModelService(this.$pigeonline),
      newModel: new CustomTopicModel(),
      newGroup: new CustomTopicModelGroup(),
      themesTabView: 'themes',
      isCreateThemeChartModal: false,
      isEditModalVisible: false,
      isSaveToCTMVisible: false,
      isAutoGenerateModalVisible: false,
      isBannedKeywordsModalVisible: false,
      isAddingCharts: false,
      localIncludeSmartCoverage: 'exclude',
      localShowCoverageDetails: 'show',
      localAllCharts: [],
      duplicateIndex: -1,
      showThemeCheckOptions: [],
      isEditSomeModalVisible: false,
      checkedThemes: [],
      checkedThemeSource: {},
      checkedThemeKeywords: [],
      someSortedThemes: [],
      fetchedCTMs: [],
      fetchedCTMThemes: [],
      modelAdd: {
        modelName: '',
      },
      savingSnapshots: false,
      learningResults: {},
      selectedBoxes: [],
      localThemes: [],
      changingColor: [],
      showSortType: false,
      showReportSettings: false,
      insightsOpenStatus: false,
      headingStyles: {
        showSentimentsHideCoverage: {
          'grid-template-columns': '30% 30% 40%',
        },
        showSentimentsShowCoverage: {
          'grid-template-columns': '20% 50% 30%',
        },
        hideSentiments: {
          'grid-template-columns': '29% 71%',
        },
      },
      rowStyles: {
        showSentimentsandCoverageDetailsStyle: {
          'grid-template-columns': '20% 1% 10% 25% 30%',
        },
        showSentimentsStyle: {
          'grid-template-columns': '25% 1% 8% 10% 41%',
        },
        hideSentimentsShowCoverageStyle: {
          'grid-template-columns': '25% 1% 8% 57%',
        },
        hideAllStyle: {
          'grid-template-columns': '25% 1% 32% 32%',
        },
      },
    };
  },
  async mounted() {
    this.refreshThemesFromParent();
  },
  async created() {
    this.updateLocalIncludeSmartCoverage();
    this.updateLocalShowCoverageDetails();
    this.updateAllCharts();
  },
  computed: {
    DATASETS_SERVICE() {
      return this.$services.DATASETS_SERVICE;
    },
    modifiedNewGroup() {
      let modifiedGroup = this.newGroup;
      modifiedGroup.name = this.modelAdd.modelName;
      modifiedGroup.owner = this.profile.django_ref_id;
      modifiedGroup.created_by = {
        name: this.profile.fullname,
        organization: '',
      };
      return modifiedGroup;
    },

    themeTypeDescription() {
      const s = this.checkedThemes[0]?.source;
      if (!s) return 'Unknown source';

      // 1. Manual creation
      if (s.type === 'manual') return 'Manually created';

      // 2. Manual unlink overrides everything
      if (s.link?.manually_unlinked) {
        return 'Originally from a custom text model (unlinked)';
      }

      // 3. Manual linking to a CTM
      if (s.link?.manually_linked_group_id) {
        return 'Manually linked to a custom text model';
      }

      // 4. Original CTM generation
      if (s.type === 'ctm') {
        return 'Generated from a custom text model';
      }

      // 5. Other model types
      const map = {
        lda: 'Generated from LDA',
        lsi: 'Generated from LSI',
        bert: 'Generated from BERT sentence matching',
        raw_search: 'Generated from a raw keyword search',
      };

      return map[s.type] || 'Unknown source';
    },

    isLinked() {
      const s = this.checkedThemes[0]?.source;
      if (!s || !s.link) return false;

      // If manually unlinked → not linked
      if (s.link.manually_unlinked) return false;

      // Manual link overrides everything
      if (s.link.manually_linked_group_id) return true;

      // CTM origin counts as linked
      if (s.type === 'ctm') return true;

      return false;
    },
    isLinkedToTheme() {
      const s = this.checkedThemes[0]?.source;
      if (!s || !s.link) return false;

      if (s.link.manually_unlinked) return false;

      // Manual link to a theme
      if (s.link.manually_linked_theme_id) return true;

      // CTM origin theme
      if (s.type === 'ctm' && s.origin.topic_model_theme_id) return true;

      return false;
    },
    currentCTMGroupId() {
      const s = this.checkedThemes[0]?.source;
      if (!s || !s.link) return null;

      if (s.link.manually_unlinked) return null;

      // Manual link overrides origin
      return (
        s.link.manually_linked_group_id || (s.type === 'ctm' ? s.origin.topic_model_group_id : null)
      );
    },
    currentCTMGroupName() {
      const s = this.checkedThemes[0]?.source;
      if (!s || !s.link) return null;

      if (s.link.manually_unlinked) return null;

      return (
        s.link.manually_linked_group_name ||
        (s.type === 'ctm' ? s.origin.topic_model_group_name : null)
      );
    },

    newKeywordsForTheme() {
      const themeKeywords = (this.checkedThemes[0]?.keyword_objects || []).map((ko) =>
        ko.keyword.toLowerCase(),
      );

      const ctmKeywords = this.currentCTMKeywordObjects.map((ko) => ko.keyword.toLowerCase());

      return themeKeywords.filter((kw) => !ctmKeywords.includes(kw));
    },

    newKeywordsFromCTM() {
      const themeKeywords = (this.checkedThemes[0]?.keyword_objects || []).map((ko) =>
        ko.keyword.toLowerCase(),
      );

      const ctmKeywords = this.currentCTMKeywordObjects.map((ko) => ko.keyword.toLowerCase());

      // CTM has keywords the theme does not
      return ctmKeywords.filter((kw) => !themeKeywords.includes(kw));
    },

    currentCTMTheme() {
      const id = this.currentCTMThemeId;
      if (!id) return null;

      return (
        this.fetchedCTMThemes.find((t) => {
          const tid = t._id?.$oid || t._id;
          return tid === id;
        }) || null
      );
    },

    currentCTMThemeId() {
      const s = this.checkedThemes[0]?.source;
      if (!s || !s.link) return null;

      if (s.link.manually_unlinked) return null;

      return (
        s.link.manually_linked_theme_id || (s.type === 'ctm' ? s.origin.topic_model_theme_id : null)
      );
    },
    currentCTMThemeName() {
      const s = this.checkedThemes[0]?.source;
      if (!s || !s.link) return null;

      if (s.link.manually_unlinked) return null;

      return (
        s.link.manually_linked_theme_name ||
        (s.type === 'ctm' ? s.origin.topic_model_theme_name : null)
      );
    },

    currentCTMKeywordObjects() {
      const id = this.currentCTMThemeId;
      if (!id) return [];

      const match = this.fetchedCTMThemes.find((t) => {
        const tid = t._id?.$oid || t._id;
        return tid === id;
      });

      return match?.keyword_objects || [];
    },

    isCTMReadOnly() {
      let status = false;
      if (Object.keys(this.checkedThemeSource).length && this.fetchedCTMs.length) {
        let filteredCTM = this.fetchedCTMs.filter(
          (ctm) => ctm.id == this.checkedThemeSource.group_id,
        );
        if (filteredCTM.length) {
          if (filteredCTM[0].access_type && filteredCTM[0].access_type == 'public__all') {
            status = true;
          }
        }
      }
      return status;
    },
    selectedThemes: function () {
      if (this.textAnalysisObject.selectedThemeUUIDs.length) {
        return this.sortedThemes.filter((theme) =>
          this.textAnalysisObject.selectedThemeUUIDs.includes(theme._id),
        );
      }
      return [];
    },

    mainThemesWidth() {
      if (
        !this.textAnalysisObject.chart_insights ||
        !this.textAnalysisObject.chart_insights.length
      ) {
        return 'width: 100%';
      }
      if (this.insightsOpenStatus) {
        return 'width: 75%';
      }
      return 'width: 100%';
    },

    headingStyle() {
      if (this.hasPreProcessedText) {
        if (this.textAnalysisObject.includeSentiments == 'exclude') {
          return this.headingStyles.hideSentiments;
        }
      }
      if (
        this.localShowCoverageDetails == 'show' &&
        this.textAnalysisObject.includeSentiments == 'include'
      ) {
        return this.headingStyles.showSentimentsShowCoverage;
      }
      if (
        this.localShowCoverageDetails == 'hide' &&
        this.textAnalysisObject.includeSentiments == 'include'
      ) {
        return this.headingStyles.showSentimentsHideCoverage;
      }
      return this.headingStyles.hideSentiments;
    },
    gridStyle() {
      if (this.hasPreProcessedText) {
        if (
          this.localShowCoverageDetails == 'show' &&
          this.textAnalysisObject.includeSentiments == 'include'
        ) {
          return this.rowStyles.showSentimentsandCoverageDetailsStyle;
        }
        if (
          this.localShowCoverageDetails == 'hide' &&
          this.textAnalysisObject.includeSentiments == 'include'
        ) {
          return this.rowStyles.showSentimentsStyle;
        }
      }
      if (
        this.localShowCoverageDetails == 'show' &&
        this.textAnalysisObject.includeSentiments == 'exclude'
      ) {
        return this.rowStyles.hideSentimentsShowCoverageStyle;
      }
      if (
        this.localShowCoverageDetails == 'hide' &&
        this.textAnalysisObject.includeSentiments == 'exclude'
      ) {
        return this.rowStyles.hideAllStyle;
      }
      return this.rowStyles.hideSentimentsShowCoverageStyle;
    },

    // replace
    isActive() {
      return this.currentState;
    },
    // replace
    checkedValue: {
      get() {
        return this.defaultState;
      },
      set(newValue) {
        this.currentState = newValue;
      },
    },
    isThemeListEmpty: function () {
      return this.localThemes && Array.isArray(this.localThemes) && this.localThemes.length === 0;
    },
    themesLength() {
      let length = 0;
      if (this.sortedThemes) {
        length = this.sortedThemes.length;
      }
      return length;
    },
    sortIcon() {
      let icon = 'percentage';
      if (this.textAnalysisObject.themesSortType == 'coverage') {
        icon = 'percentage';
      }
      if (this.textAnalysisObject.themesSortType == 'sentiment') {
        icon = 'percentage';
      }
      if (this.textAnalysisObject.themesSortType == 'alphabetical') {
        icon = 'alphabet';
      }
      if (this.textAnalysisObject.themesSortType == 'created') {
        icon = 'timeAdd';
      }
      // if (this.textAnalysisObject.themesSortType == 'modified') {
      //   icon = "timeCheck"
      // }
      return icon;
    },
    // Whenever time series is included, show themes over time as a chart. Later, if sentiment is on, automatically add this as a second line
    themeDualAxisCharts() {
      let theme_charts = [];

      for (let i = 0; i < this.sortedThemes.length; i++) {
        // Copy format found in existing peformance charts
        // but add additional axis
        let chart_data = [];
        if (this.sortedThemes[i].time_series && this.sortedThemes[i].time_series.length) {
          let chartObject = {
            value: 0,
            label: this.sortedThemes[i].name,
            unique_numbers_count_dict: {},
            theme_color: this.sortedThemes[i].theme_color,
          };

          chartObject['time_series_scores'] = this.sortedThemes[i]['time_series'];

          chart_data.push(chartObject);
        }
        let this_chart = {
          segmented_by: '',
          filtered_by: '',
          chart_data: chart_data,
        };
        theme_charts.push(this_chart);
      }
      return theme_charts;
    },
  },
  methods: {
    changeThemesTabView() {
      if (this.themesTabView == 'charts') {
        this.themesTabView = 'themes';
      } else {
        this.themesTabView = 'charts';
      }
    },
    showCreateThemeChartModal() {
      this.isCreateThemeChartModal = true;
    },
    closeCreateThemeChartModal() {
      this.isCreateThemeChartModal = false;
    },
    async addNewChart(selectedThemes, filter_name, segment_param) {
      let all_charts = this.deepCloneObj(this.localAllCharts);
      this.isAddingCharts = true;

      // ---------------------------------------------------------
      // SEGMENTED MODE
      // ---------------------------------------------------------
      if (segment_param) {
        const segmentedQuestion = this.$store.getters['datasetDetails/getClientQuestions'].find(
          (q) => q._id.$oid === segment_param,
        );

        if (!segmentedQuestion) {
          this.isAddingCharts = false;
          return;
        }
        // Build theme_ids
        const themes_to_check = selectedThemes.map((t) => (t._id?.$oid ? t._id.$oid : t._id));
        // Smart coverage flag
        let smart_coverage = false;
        if (
          this.textAnalysisObject.includeSmartCoverage &&
          this.textAnalysisObject.includeSmartCoverage === 'include'
        ) {
          smart_coverage = true;
        }

        // Project ID normalization
        let proj_id = this.project.id?.$oid || this.project.id;

        // Base payload for backend
        const payload = {
          client_question_id: this.selectedTextQuestionId,
          project_id: proj_id,
          text_analysis_uuid: this.textAnalysisObject.uuid,
          theme_ids: themes_to_check,
          segment_question_id: segment_param, // <-- REQUIRED
          smart_coverage: smart_coverage,
          filter_params: {}, // base filter (optional)
          time_series: this.textAnalysisObject.time_series || 'None',
        };

        // Call backend ONCE
        const segmentedResults = await this.TEXT_SERVICE.computeSegmentedCoverage(payload);
        // ---------------------------------------------------------
        // Group results by theme
        // ---------------------------------------------------------
        const groupedByTheme = {};
        for (const row of segmentedResults) {
          if (!groupedByTheme[row.theme_id]) {
            groupedByTheme[row.theme_id] = [];
          }
          groupedByTheme[row.theme_id].push(row);
        }

        // ---------------------------------------------------------
        // Build chart_data in your existing format
        // ---------------------------------------------------------
        const all_chart_data = [];

        for (let i = 0; i < selectedThemes.length; i++) {
          const theme = selectedThemes[i];
          const theme_id = theme._id?.$oid || theme._id;

          const rows = groupedByTheme[theme_id] || [];
          const value_scores = rows.map((r) => ({
            overall_mean: this.roundToTwo(
              (r.filtered_coverage.matching_responses.length / r.filtered_coverage.denominator) *
                100,
            ),
            segment_value: r.segment_value,
            question_title: segmentedQuestion.question_title,
            question_text: segmentedQuestion.question_text,
            client_question_title: theme.name,
            time_series_scores: r.time_series || [],
          }));
          all_chart_data.push({
            _id: theme._id,
            client_question_analysis: {
              question_title: theme.name,
              unique_segments_count_dict: value_scores,
            },
          });
        }

        // ---------------------------------------------------------
        // Final chart object
        // ---------------------------------------------------------
        const this_chart = {
          segmented_by: segmentedQuestion.question_title,
          filtered_by: '',
          chart_data: all_chart_data,
        };

        all_charts.push(this_chart);
        this.localAllCharts = all_charts;
        this.$emit('updateAllCharts', all_charts);
        this.isAddingCharts = false;
        return;
      }

      // ---------------------------------------------------------
      // NON-SEGMENTED MODE (unchanged)
      // ---------------------------------------------------------
      // TODO does this not handle filter_params? worth ticketing if not already
      let chart_data = [];
      for (let i = 0; i < selectedThemes.length; i++) {
        let coverage = this.roundToTwo(
          this.parseCoveragePercentage(selectedThemes[i], this.unsortedResponses.length),
        );

        let chartObject = {
          value: coverage,
          label: selectedThemes[i].name,
          unique_numbers_count_dict: selectedThemes[i].coverage.total,
          theme_color: selectedThemes[i].theme_color,
        };

        if (selectedThemes[i].time_series?.length) {
          chartObject.time_series_scores = selectedThemes[i].time_series;
        }

        chart_data.push(chartObject);
      }

      const this_chart = {
        segmented_by: '',
        filtered_by: filter_name || '',
        chart_data: chart_data,
      };

      all_charts.push(this_chart);
      this.localAllCharts = all_charts;
      this.$emit('updateAllCharts', all_charts);
      this.isAddingCharts = false;
    },

    deleteChart(index) {
      let all_charts = this.deepCloneObj(this.localAllCharts);
      all_charts.splice(index, 1);
      this.localAllCharts = all_charts;
      this.$emit('updateAllCharts', all_charts);
    },
    updateLocalIncludeSmartCoverage() {
      this.localIncludeSmartCoverage = this.textAnalysisObject.includeSmartCoverage;
    },
    updateLocalShowCoverageDetails() {
      this.localShowCoverageDetails = this.textAnalysisObject.showCoverageDetails;
    },
    updateAllCharts() {
      if (this.textAnalysisObject.allCharts) {
        this.localAllCharts = this.textAnalysisObject.allCharts;
      }
    },
    switchSort(sort_type) {
      this.$emit('updateSortType', sort_type);
      this.showSortType = false;
    },
    switchSortOrder() {
      if (this.textAnalysisObject.themesSortOrder == 'descending') {
        this.$emit('updateSortOrder', 'ascending');
      } else {
        this.$emit('updateSortOrder', 'descending');
      }
    },
    openEditSomeThemes() {
      if (!this.propReadOnly) {
        this.someSortedThemes = this.checkedThemes;
        this.isEditSomeModalVisible = true;
      }
    },
    openSaveCTM() {
      if (!this.propReadOnly) {
        this.isSaveToCTMVisible = !this.isSaveToCTMVisible;
      }
    },
    closeSavingToCTM() {
      this.isSaveToCTMVisible = false;
      this.learningResults = {};
    },
    addToShowThemeCheckOptions(checked_theme) {
      let checkedThemes = this.deepCloneObj(this.checkedThemes);
      let checkedThemesFilter = [];
      checkedThemesFilter = checkedThemes.filter((theme) => theme._id == checked_theme._id);
      if (checkedThemesFilter.length) {
        this.checkedThemes = checkedThemes.filter((theme) => theme._id != checked_theme._id);
      } else {
        this.checkedThemes.push(checked_theme);
      }

      let showThemeCheckOptions = this.deepCloneObj(this.showThemeCheckOptions);
      let opennedOption = [];
      opennedOption = showThemeCheckOptions.filter((theme) => theme._id == checked_theme._id);
      if (opennedOption.length) {
        this.showThemeCheckOptions = showThemeCheckOptions.filter(
          (theme) => theme._id != checked_theme._id,
        );
      } else {
        this.showThemeCheckOptions.push(checked_theme);
      }
      this.isSaveToCTMVisible = false;
    },
    newGroupCreated(model) {
      this.setThisCTM(model, this.checkedThemes[0]);
    },
    async saveNewKeywords() {
      const ctmTheme = this.currentCTMTheme;
      if (!ctmTheme) return;

      // Existing keywords from keyword_objects
      const existing = ctmTheme.keyword_objects?.map((ko) => ko.keyword) || [];

      // Add new keywords
      const updatedKeywords = [...existing, ...this.newKeywordsForTheme];

      // Send to backend (input-only field)
      await this.CUSTOM_TOPIC_MODEL_SERVICE.update(ctmTheme._id.$oid || ctmTheme._id, {
        keywords: updatedKeywords,
      });

      // Optimistic UI update
      ctmTheme.keyword_objects = updatedKeywords.map((k) => ({ keyword: k }));
    },

    async saveLearningSnapshots() {
      this.savingSnapshots = true;
      let theme_id = this.checkedThemes[0]._id;
      if (theme_id.$oid) theme_id = theme_id.$oid;
      let proj_id = this.project.id?.$oid || this.project.id;

      const payload = {
        client_question_id: this.selectedTextQuestionId,
        theme_id: theme_id,
        project_id: proj_id,
      };
      let summary = await this.CUSTOM_TOPIC_MODEL_SERVICE.saveLearnings(payload);
      if (summary) {
        this.learningResults = summary.summary;
      }
      this.savingSnapshots = false;
    },

    async fetchCTMGroups() {
      this.fetchedCTMs = await fetchGroups();
    },

    async setThisCTM(model, theme, skip) {
      if (skip) return;

      const themeId = theme._id?.$oid || theme._id;

      // Optimistic UI update
      const localTheme = this.localThemes.find((t) => t._id === themeId);
      if (localTheme) {
        localTheme.source = localTheme.source || {};
        localTheme.source.link = localTheme.source.link || {};

        localTheme.source.link.manually_linked_group_id = model.id;
        localTheme.source.link.manually_linked_group_name = model.name;
        localTheme.source.link.manually_linked_theme_id = null;
        localTheme.source.link.manually_linked_theme_name = null;
        localTheme.source.link.manually_unlinked = false;
      }

      // Atomic patch
      this.$emit('updateTheme', {
        _id: themeId,
        fields_to_update: {
          'source.link.manually_linked_group_id': model.id,
          'source.link.manually_linked_group_name': model.name,
          'source.link.manually_linked_theme_id': null,
          'source.link.manually_linked_theme_name': null,
          'source.link.manually_unlinked': false,
        },
      });

      this.checkedThemes[0] = localTheme;
      this.setFetchedCTMThemes();
    },

    async setThisCTMTheme(modelThemeId, theme) {
      const themeId = theme._id?.$oid || theme._id;

      // Find the CTM theme object so we can extract its name
      const modelTheme = this.fetchedCTMThemes.find((t) => (t._id?.$oid || t._id) === modelThemeId);

      const localTheme = this.localThemes.find((t) => t._id === themeId);
      if (localTheme) {
        localTheme.source = localTheme.source || {};
        localTheme.source.link = localTheme.source.link || {};

        localTheme.source.link.manually_linked_theme_id = modelThemeId;
        localTheme.source.link.manually_linked_theme_name = modelTheme?.name || null;
      }

      this.$emit('updateTheme', {
        _id: themeId,
        fields_to_update: {
          'source.link.manually_linked_theme_id': modelThemeId,
          'source.link.manually_linked_theme_name': modelTheme?.name || null,
        },
      });

      this.checkedThemes[0] = localTheme;

      await this.setFetchedCTMThemes();

      if (this.newKeywordsFromCTM.length) {
        await this.syncKeywordsFromCTM();
      }
    },

    async setNewCTMTheme() {
      const baseTheme = this.checkedThemes[0];
      if (!baseTheme?.source?.link?.manually_linked_group_id) return;
      // Convert keyword_objects -> keywords (input-only)
      const keywords = (baseTheme.keyword_objects || []).map((ko) => ko.keyword);

      const newModel = {
        ...this.newModel,
        name: baseTheme.name,
        keywords, // backend converts -> keyword_objects
        source: { name: '', url: '' },
        group_id: baseTheme.source.link.manually_linked_group_id,
      };

      const created = await this.CUSTOM_TOPIC_MODEL_SERVICE.create(newModel);

      if (created) {
        await this.setThisCTMTheme(created._id.$oid || created._id, baseTheme);
      }
    },

    async removeThisCTM(theme) {
      const themeId = theme._id?.$oid || theme._id;

      const localTheme = this.localThemes.find((t) => t._id === themeId);
      if (localTheme) {
        localTheme.source.link.manually_linked_group_id = null;
        localTheme.source.link.manually_linked_theme_id = null;
        localTheme.source.link.manually_linked_theme_name = null;
        localTheme.source.link.manually_unlinked = true;
      }

      this.$emit('updateTheme', {
        _id: themeId,
        fields_to_update: {
          'source.link.manually_linked_group_id': null,
          'source.link.manually_linked_theme_id': null,
          'source.link.manually_linked_theme_name': null,
          'source.link.manually_unlinked': true,
        },
      });

      this.checkedThemes[0] = localTheme;
      this.fetchCTMGroups();
      this.fetchedCTMThemes = [];
      this.checkedThemeSource = {};
    },

    async relinkThisCTM() {
      const theme = this.checkedThemes[0];
      if (!theme?.source?.link?.manually_unlinked) return;

      const themeId = theme._id?.$oid || theme._id;

      const localTheme = this.localThemes.find((t) => t._id === themeId);
      if (localTheme) {
        localTheme.source.link.manually_linked_group_id = null;
        localTheme.source.link.manually_linked_theme_id = null;
        localTheme.source.link.manually_linked_theme_name = null;
        localTheme.source.link.manually_unlinked = false;
      }

      this.$emit('updateTheme', {
        _id: themeId,
        fields_to_update: {
          'source.link.manually_linked_group_id': null,
          'source.link.manually_linked_theme_id': null,
          'source.link.manually_linked_theme_name': null,
          'source.link.manually_unlinked': false,
        },
      });

      this.checkedThemes[0] = localTheme;

      await this.setFetchedCTMThemes();

      if (this.newKeywordsFromCTM.length) {
        await this.syncKeywordsFromCTM();
      }
    },

    async setFetchedCTMThemes() {
      const groupId = this.currentCTMGroupId;
      if (!groupId) {
        this.fetchedCTMThemes = [];
        return;
      }

      this.fetchedCTMThemes = await fetchTopicModels(groupId);
    },

    async syncKeywordsFromCTM() {
      const theme = this.checkedThemes[0];
      const themeId = theme?._id?.$oid || theme?._id;
      const newKeywords = this.newKeywordsFromCTM;

      if (!theme || !newKeywords.length) return;

      // Reuse the same pattern as addKeyword, just batched
      this.$emit('updateTheme', {
        _id: themeId,
        keywords_to_add: newKeywords,
      });

      // Optimistic UI update
      theme.keyword_objects = [
        ...(theme.keyword_objects || []),
        ...newKeywords.map((k) => ({ keyword: k })),
      ];
    },

    isChecked(theme) {
      const allThemes = this.textAnalysisObject.selectedThemeUUIDs;
      if (allThemes.includes(theme._id)) {
        return true;
      }
      return false;
    },

    async duplicateTheme() {
      if (this.propReadOnly) return;
      const sortedThemes = this.sortedThemes;
      const checkedThemes = this.checkedThemes;

      let usedColors = sortedThemes.map((t) => t.theme_color);

      for (const original of checkedThemes) {
        // Assign a new color
        const newColor = (await this.assignColor(usedColors)) || '#6a88aa';
        usedColors.push(newColor);

        // Build the new theme object
        const newTheme = {
          text_analysis_uuid: this.textAnalysisObject.uuid,
          name: original.name + '_copy',
          theme_color: newColor,
          created_on: moment().valueOf(),

          // Copy content fields
          keyword_objects: original.keyword_objects || [],
          notes: original.notes || [],
          dropped: original.dropped || [],
          ml_dropped: original.ml_dropped || [],
          // human_dropped_ml_notes: original.human_dropped_ml_notes || [], Not necessary to keep this in a duplicated theme since we remove the source
          // Copy coverage for instant UI
          coverage: original.coverage || {},
          filtered_coverage: original.filtered_coverage || {},

          // Status
          status: original.keyword_objects?.length ? 'updating' : 'ready',
        };

        // Create the new theme
        const createdTheme = await this.TEXT_SERVICE.createTheme(newTheme);
        if (createdTheme) {
          let theme_id = createdTheme._id.$oid ? createdTheme._id.$oid : createdTheme._id;
          this.$emit('refreshTheme', theme_id);
        }
      }

      // Reset UI
      this.showThemeCheckOptions = [];
      this.selectedBoxes = [];
      this.checkedThemes = [];
    },

    async copyAndMerge(also_delete) {
      if (this.propReadOnly) return;

      const sortedThemes = this.sortedThemes;
      const checkedThemes = this.checkedThemes;

      // 1. Assign a new color
      const usedColors = sortedThemes.map((t) => t.theme_color);
      const newColor = (await this.assignColor(usedColors)) || '#6a88aa';

      // 2. Build merged content (but don't send it to createTheme)
      const merged = {
        name: '',
        keyword_objects: [],
        notes: [],
        dropped: [],
        ml_dropped: [],
      };

      for (let i = 0; i < checkedThemes.length; i++) {
        const t = checkedThemes[i];

        if (t.keyword_objects?.length) {
          merged.keyword_objects = merged.keyword_objects.concat(t.keyword_objects);
        }
        if (t.notes?.length) {
          merged.notes = merged.notes.concat(t.notes);
        }
        if (t.dropped?.length) {
          merged.dropped = [...new Set(t.dropped.filter(Boolean))];
        }

        if (t.ml_dropped?.length) {
          merged.ml_dropped = [...new Set(t.ml_dropped.filter(Boolean))];
        }

        if (t.human_dropped_ml_notes?.length) {
          merged.human_dropped_ml_notes = merged.human_dropped_ml_notes.concat(
            t.human_dropped_ml_notes,
          );
        }

        merged.name += t.name;
        if (i < checkedThemes.length - 1) {
          merged.name += ' + ';
        }
      }

      // 3. Ensure unique name
      const existingNames = sortedThemes.map((t) => t.name);
      if (existingNames.includes(merged.name)) {
        for (let x = 1; x < 100; x++) {
          if (!existingNames.includes(merged.name + x)) {
            merged.name = merged.name + x;
            break;
          }
        }
      }

      // 4. Create a minimal shell theme
      const shellPayload = {
        text_analysis_uuid: this.textAnalysisObject.uuid,
        created_on: moment().valueOf(),
        theme_color: newColor,
        name: merged.name,
      };

      const createdTheme = await this.TEXT_SERVICE.createTheme(shellPayload);
      if (!createdTheme) return;

      const theme_id = createdTheme._id.$oid || createdTheme._id;

      // 5. Immediately update via the normal mutation pipeline
      this.$emit('updateTheme', {
        _id: theme_id,
        keywords_to_add: merged.keyword_objects.map((k) => k.keyword),
        notes_to_add: merged.notes,
        fields_to_update: {
          dropped: merged.dropped,
        },
      });

      this.$emit('refreshTheme', theme_id);

      // 6. Optionally delete originals
      if (also_delete) {
        this.confirmedDelete();
      } else {
        this.showThemeCheckOptions = [];
        this.selectedBoxes = [];
        this.checkedThemes = [];
      }
    },

    onClickMergeAndDelete() {
      if (!this.propReadOnly) {
        this.setConfirmText({
          btn: 'Yes',
          title: 'Confirm Merge and Delete',
          message:
            'This will combine themes and delete the originals. Are you sure you want to delete these themes?',
        });
        this.setConfirmSourceComponent('themes');
        this.setConfirmType('merge-delete');
        this.setConfirmIsVisible(true);
        this.setConfirmStatus(false);
      }
    },

    onClickDelete() {
      if (!this.propReadOnly) {
        this.setConfirmText({
          btn: 'Yes',
          title: 'Confirm Delete',
          message: 'Are you sure you want to delete this theme?',
        });
        this.setConfirmSourceComponent('themes');
        this.setConfirmType('delete');
        this.setConfirmIsVisible(true);
        this.setConfirmStatus(false);
      }
    },
    async confirmedDelete() {
      let allThemesToDelete = this.deepCloneObj(this.checkedThemes);
      for (let i = 0; i < allThemesToDelete.length; i++) {
        await this.saveDeletedTheme(allThemesToDelete[i]._id);
        this.$emit('removeTheme', allThemesToDelete[i]._id);
      }
      this.selectedBoxes = [];
      this.checkedThemes = [];
      this.showThemeCheckOptions = [];
    },
    showChangeColor(index) {
      let filteredThemes = [];
      filteredThemes = this.changingColor.filter((theme) => theme == index);
      if (filteredThemes.length) {
        this.changingColor = this.changingColor.filter((theme) => theme != index);
      } else {
        this.changingColor = [];
        this.changingColor.push(index);
      }
    },

    updateIncludeSmartCoverage() {
      let option = 'exclude';
      if (!this.localIncludeSmartCoverage || this.localIncludeSmartCoverage == 'exclude') {
        option = 'include';
      }
      this.localIncludeSmartCoverage = option;
      this.setIncludeSmartCoverage(option);
    },
    async onRemoveNote(selection) {
      if (!selection || !selection.responseId) return;

      this.setShowSpinner(true);

      // Find the theme that contains this note
      const theme = this.sortedThemes.find((t) =>
        t.notes?.some(
          (n) => n.responseId === selection.responseId && n.startIndex === selection.startIndex,
        ),
      );

      if (!theme) {
        this.setShowSpinner(false);
        return;
      }

      // Emit the atomic patch
      this.$emit('updateTheme', {
        _id: theme._id,
        notes_to_remove: [selection.responseId],
      });

      this.setShowSpinner(false);
    },

    findResponses(theme) {
      let themeResponses = [];

      const idsToIgnore = [
        ...new Set([...(theme.dropped ?? []), ...(theme.ml_dropped ?? [])].filter(Boolean)),
      ];

      let keywordIdsToFetch = [];
      // Note: for the below we could use matching_keywords.length, or total, both should be equal
      if (
        this.textAnalysisObject.filterParams &&
        Object.keys(this.textAnalysisObject.filterParams).length &&
        theme.filtered_coverage?.matching_keywords
      ) {
        if (
          theme.filtered_coverage.matching_keywords &&
          theme.filtered_coverage.matching_keywords.length > 0
        ) {
          keywordIdsToFetch = this.unsortedResponses
            .filter((response) =>
              theme.filtered_coverage.matching_keywords.some((match) =>
                response.response.toLowerCase().includes(match.toLowerCase()),
              ),
            )
            .map((response) => response._id || response.id);
        }
      } else {
        if (theme.coverage.matching_keywords && theme.coverage.matching_keywords.length > 0) {
          keywordIdsToFetch = this.unsortedResponses
            .filter((response) =>
              theme.coverage.matching_keywords.some((match) =>
                response.response.toLowerCase().includes(match.toLowerCase()),
              ),
            )
            .map((response) => response._id || response.id);
        }
      }

      keywordIdsToFetch = keywordIdsToFetch.filter((id) => !idsToIgnore.includes(id));
      let noteIdsToFetch = [];
      if (theme.notes && theme.notes.length > 0) {
        noteIdsToFetch = theme.notes
          .filter(
            (el) => !idsToIgnore.includes(el.responseId) && !noteIdsToFetch.includes(el.responseId),
          )
          .map((el) => el.responseId);
      }
      if (noteIdsToFetch.length || keywordIdsToFetch.length) {
        if (this.unsortedResponses) {
          themeResponses = this.unsortedResponses.filter(
            (response) =>
              noteIdsToFetch.includes(response.id) || keywordIdsToFetch.includes(response.id),
          );
        }
      }
      return themeResponses;
    },
    getIdsToFetch(theme) {
      const idsToIgnore = [
        ...new Set([...(theme.dropped ?? []), ...(theme.ml_dropped ?? [])].filter(Boolean)),
      ];

      let idsToFetch = [];
      // Note: for the below we could use matching_keywords.length, or total, both should be equal
      if (
        this.textAnalysisObject.filterParams &&
        Object.keys(this.textAnalysisObject.filterParams).length &&
        theme.filtered_coverage.matching_keywords
      ) {
        if (
          theme.filtered_coverage.matching_keywords &&
          theme.filtered_coverage.matching_keywords.length > 0
        ) {
          idsToFetch = theme.filtered_coverage.matching_keywords
            .filter((el) => !idsToIgnore.includes(el.responseId))
            .map((el) => el.responseId);
        }
      } else {
        if (theme.coverage.matching_keywords && theme.coverage.matching_keywords.length > 0) {
          idsToFetch = theme.coverage.matching_keywords
            .filter((el) => !idsToIgnore.includes(el.responseId))
            .map((el) => el.responseId);
        }
      }

      if (theme.notes && theme.notes.length > 0) {
        idsToFetch = theme.notes
          .filter(
            (el) => !idsToIgnore.includes(el.responseId) && !idsToFetch.includes(el.responseId),
          )
          .map((el) => el.responseId);
      }
      return idsToFetch;
    },
    updateTextObject(cleanedProject) {
      let object = {
        project: cleanedProject,
        scroll: 'themes',
      };
      this.$emit('updateTextObject', object);
    },
    deepCloneObj(obj) {
      // deep clones an object using JSON stringify (data loss might occur)
      if (Array.isArray(obj)) {
        return obj.map((item) => JSON.parse(JSON.stringify(item)));
      } else if (typeof obj == 'object') {
        return JSON.parse(JSON.stringify(obj));
      }
    },
    refreshThemesFromParent() {
      this.localThemes = this.sortedThemes;
      if (this.$refs.ThemesEditModalRef) {
        this.$refs.ThemesEditModalRef.refreshThemesFromParent();
      }
      if (this.$refs.ThemesAutoGenerateModalRef) {
        this.$refs.ThemesAutoGenerateModalRef.refreshThemesFromParent();
      }
    },
    toggleTheme() {
      let filteredThemes = this.checkedThemes.filter((theme) => theme.coverage.total > 0);
      let themeIds = filteredThemes.map((theme) => theme._id);
      if (themeIds.length) {
        this.setSelectedThemeUUIDs(themeIds);
      }
    },
    selectThisResponse(response_id) {
      if (response_id) {
        let these_responses = [];
        these_responses.push(response_id);
        this.setSelectedResponseIds(these_responses);
      }
    },
    // Used by EditableCoveragePopup
    async addKeyword(keyword_info) {
      const theme = keyword_info.theme;
      const themeId = theme._id.$oid || theme._id;

      this.$emit('updateTheme', {
        _id: themeId,
        keywords_to_add: [keyword_info.text],
      });
    },

    async removeKeyword(keyword_info) {
      const theme = keyword_info.theme;
      const themeId = theme._id.$oid || theme._id;

      this.$emit('updateTheme', {
        _id: themeId,
        keywords_to_remove: [keyword_info.text],
      });
    },

    async changeThemeColor(color, themeId) {
      const id = themeId.$oid || themeId;

      this.$emit('updateTheme', {
        _id: id,
        fields_to_update: {
          theme_color: color,
        },
      });

      this.changingColor = [];
    },
    async addNewNote(note_details) {
      const theme = note_details.theme;
      const themeId = theme._id?.$oid || theme._id;

      const sentence = note_details.sentence;

      const note = {
        content: sentence.text,
        length: sentence.end_idx - sentence.start_idx,
        responseId: sentence.response_id,
        row_index: sentence.row_index,
        source: {
          questionId: this.textAnalysisObject.selectedTextQuestion._id,
          responseText: '',
        },
        startIndex: sentence.start_idx,
        text: '',
      };

      this.$emit('updateTheme', {
        _id: themeId,
        notes_to_add: [note],
      });
    },

    showThemeToggleButton(theme) {
      if (theme.length) {
        return true;
      }
      return false;
    },
    closeModalBannedKeywords() {
      this.isBannedKeywordsModalVisible = false;
    },
    closeModalAutoGenerate() {
      this.isAutoGenerateModalVisible = false;
    },
    closeModalEditThemes() {
      this.isEditModalVisible = false;
    },
    closeModalEditSomeThemes() {
      this.selectedBoxes = [];
      this.checkedThemes = [];
      this.showThemeCheckOptions = [];
      this.isEditSomeModalVisible = false;
    },
    calcRespondentSentimentTotals(data) {
      return data.reduce(
        (totals, data) => {
          if (data > -0.05 && data < 0.05) totals.neu++;
          if (data >= 0.05) totals.pos++;
          if (data <= -0.05) totals.neg++;
          return totals;
        },
        { neu: 0, pos: 0, neg: 0 },
      );
    },
    generatePosNegData: function (data, themeName) {
      if (!data || !Array.isArray(data)) data = [];
      const SCALE_DOWN_FACTOR = Math.ceil(Math.max(data.length) / 30);
      let filteredData = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i]?.response_sentiment_bert?.compound_score) {
          let default_score = data[i].response_sentiment_bert.compound_score;
          if (this.textAnalysisObject.adjustedSentiments) {
            const adjustedSentiment = this.textAnalysisObject.adjustedSentiments.filter(
              (val) => val.responseId == data[i].id,
            );

            if (adjustedSentiment != null && adjustedSentiment.length) {
              default_score = adjustedSentiment[0].adjustedSentiment;
            }
          }

          filteredData.push(default_score);
        }
      }

      const totals = this.calcRespondentSentimentTotals(filteredData);
      const description =
        `The chart shows sentiments for each text entry ` +
        `in theme <em>${themeName}</em>. It shows ${this.roundToTwo(totals.neg)} ` +
        `responses have a negative sentiment, ${this.roundToTwo(totals.neu)} ` +
        `are netural, and ${this.roundToTwo(totals.pos)} are positive.`;

      let shortenedData = filteredData;
      if (filteredData.length > 1000) {
        shortenedData = filteredData.filter((_, index) => index % SCALE_DOWN_FACTOR === 0);
      }
      return new PigeonDocNodeModel({
        type: 'positiveNegativeBarChartSmall',
        content: {
          data: shortenedData,
          meta: {
            veryPositiveColour: 'var(--very-positive-soft)',
            positiveColour: 'var(--somewhat-positive-soft)',
            neutralColour: 'var(--neutral-soft)',
            negativeColour: 'var(--somewhat-negative-soft)',
            veryNegativeColour: 'var(--very-negative-soft)',
          },
        },
        meta: {
          description: description,
        },
      });
    },

    roundToTwo(num) {
      return +(Math.round(num + 'e+2') + 'e-2');
    },
  },
  watch: {
    confirmStatus: async function (val) {
      if (val && this.confirmSourceComponent === 'themes' && this.confirmType === 'delete') {
        await this.confirmedDelete();
        this.setConfirmStatus(false);
      }

      if (val && this.confirmSourceComponent === 'themes' && this.confirmType === 'merge-delete') {
        await this.copyAndMerge(true);
        this.setConfirmStatus(false);
      }
    },
    allCharts: async function (val) {
      if (val && val.length) {
        this.updateAllCharts();
      }
    },
    isSaveToCTMVisible: async function (val) {
      if (val) {
        this.fetchCTMGroups();
        if (!this.isLinked) {
          if (!this.checkedThemes[0].source) {
            this.checkedThemes[0].source = {};
          }
        }
        if (this.isLinked && !this.isLinkedtoTheme) {
          this.setFetchedCTMThemes();
        }
      }
      if (!val) {
        this.checkedThemeSource = {};
        this.fetchedCTMs = [];
        this.fetchedCTMThemes = [];
      }
    },
  },
};
</script>
<style scoped>
/* ------------------------------
   Modal container
------------------------------ */
.ctm-modal {
  position: absolute;
  z-index: 10;
  background: white;
  width: 40rem;
  margin-left: -1rem;
  margin-top: 25rem;
  border: 1px solid var(--outline-colour);
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  color: var(--base-colour);
}

.ctm-modal__inner {
  display: flex;
  flex-direction: column;
  padding: 1rem;
}

/* ------------------------------
   Header
------------------------------ */
.ctm-modal__header {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.ctm-modal__header .modal-close-btn {
  margin-left: auto;
}

/* ------------------------------
   Sections
------------------------------ */
.ctm-modal__section {
  padding: 0.5rem 0;
  margin-bottom: 0.5rem;
}

/* ------------------------------
   Rows
------------------------------ */
.ctm-modal__row {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0.5rem 0;
}

/* ------------------------------
   Status icons
------------------------------ */
.status-icon {
  display: flex;
  height: 1.25rem;
  width: 1.25rem;
  border-radius: 999px;
}

.status-icon.ok {
  color: var(--tom-thumb-green);
  background: var(--pixie-green);
}

.status-icon.bad {
  color: var(--totem-pole-red);
  background: var(--linen-red);
}

/* ------------------------------
   Keyword scroll area
------------------------------ */
.ctm-modal__section .keywords-input-badge {
  font-size: 0.8rem;
  padding: 0.15rem 0.5rem;
  border-radius: 12px;
  margin-right: 0.25rem;
  margin-bottom: 0.25rem;
  white-space: nowrap;
  color: white;
}

/* ------------------------------
   CTM list
------------------------------ */
.ctm-list {
  max-height: 20rem;
  overflow-y: auto;
  margin-top: 0.5rem;
}

.ctm-list .hoverable-background {
  padding: 0.5rem 1rem;
  cursor: pointer;
}

.ctm-list .hoverable-background:hover {
  background-color: var(--outline-colour);
}

.ctm-list .hoverable-background.read-only {
  background-color: var(--outline-colour);
  color: var(--base-colour);
  cursor: not-allowed;
}

.ctm-name {
  color: var(--primary);
  font-weight: 800;
}

.ctm-owner {
  margin-left: 1rem;
}

/* ------------------------------
   Create CTM row
------------------------------ */
.ctm-create-row {
  display: flex;
  flex-direction: row;
  padding: 1rem;
  width: 80%;
  align-items: center;
}

.ctm-create-row input {
  flex: 1;
  margin-right: 1rem;
}

/* ------------------------------
   Remove link button
------------------------------ */
.remove-link-btn {
  background-color: var(--error-bg-colour);
  color: var(--error-text-colour);
  padding: 0 0.5rem;
  min-height: 1.5rem;
  height: 1.5rem;
  border: 1px solid var(--shilo-red);
  margin-left: 1rem;
}

.ctm-modal__section .btn-save {
  padding: 0.25rem 0.75rem;
  min-height: 1.75rem;
  height: 1.75rem;
  font-size: 0.85rem;
}

.btn-save {
  padding: 0.25rem 0.75rem;
  min-height: 1.75rem;
  height: 1.75rem;
  font-size: 0.85rem;
}

.pill {
  font-size: 0.8rem;
  color: white;
}

.snapshot-list {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: flex-start;
}

/* Each snapshot card becomes a flex item */
.snapshot-item {
  flex: 1 1 300px; /* grows, shrinks, minimum width */
  max-width: 360px; /* prevents cards from getting too wide */
}

/* Snapshot card styling */
.snapshot-summary {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px 18px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  font-family:
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
  color: #0f172a;
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
}

/* Optional: make delete button sit at the bottom of the card */
.snapshot-summary {
  display: flex;
  flex-direction: column;
}

.snapshot-delete {
  margin-top: auto; /* pushes it to the bottom */
}

/* Existing styles preserved */
.snapshot-date {
  font-size: 0.9rem;
  margin-bottom: 4px;
}

.snapshot-section {
  margin-bottom: 14px;
}

.snapshot-title {
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 6px;
}

.snapshot-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

/* Ensure list items align nicely with the new icon */
.snapshot-section li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.snapshot-section li span:nth-child(2) {
  flex: 1; /* label expands naturally */
}

.snapshot-section li span {
  color: #64748b;
}

.snapshot-section li strong {
  color: #0f172a;
  font-weight: 600;
}

.snapshot-footer {
  border-top: 1px solid #e2e8f0;
  padding-top: 10px;
  margin-top: 10px;
  font-size: 0.9rem;
  color: #64748b;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.snapshot-footer strong {
  color: #0f172a;
}

.snapshot-note {
  font-style: italic;
}

/* Icon beside each metric */
.signal {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  margin-right: 6px;
  font-size: 0.8rem;
  font-weight: 700;
}

.signal.positive {
  color: #16a34a; /* green-600 */
}

.signal.negative {
  color: #dc2626; /* red-600 */
}
</style>
